import type {
  BehaviorFunction,
  BehaviorSubject,
  GoalDomain,
  GoalType,
  Status,
} from "api/types/aba";

export interface GoalFormValues {
  behavior_subject: BehaviorSubject | "";
  goal_type: GoalType | "";
  title: string;
  domain: GoalDomain | "";
  status: Status;
  /** Maps to the "Goal Statement" field in the UI (observable behavior, conditions, teaching approach) */
  description: string;
  general_session_instructions: string;
  reinforcement_context: string;
  strategy_notes: string;
  // Section 1.5 — only required when goal_type === "behavior-reduction"
  operational_definition: string;
  hypothesized_functions: BehaviorFunction[];
  common_antecedents: string;
  // Section 2
  mastery_definition: string;
  generalization_definition: string;
  resources: Array<{ url: string; title: string }>;
}

export const GOAL_FORM_INITIAL_VALUES: GoalFormValues = {
  behavior_subject: "client",
  goal_type: "skill-acquisition",
  title: "",
  domain: "",
  status: "not-active",
  description: "",
  general_session_instructions: "",
  reinforcement_context: "",
  strategy_notes: "",
  operational_definition: "",
  hypothesized_functions: [],
  common_antecedents: "",
  mastery_definition: "",
  generalization_definition: "",
  resources: [],
};

export const BEHAVIOR_SUBJECT_OPTIONS: Array<{ value: BehaviorSubject; label: string }> = [
  { value: "client", label: "Client" },
  { value: "caregiver", label: "Caregiver" },
];

export const GOAL_TYPE_OPTIONS: Array<{ value: GoalType; label: string }> = [
  { value: "skill-acquisition", label: "Skill Acquisition" },
  { value: "behavior-reduction", label: "Behavior Reduction" },
];

export const DOMAIN_OPTIONS: Array<{ value: GoalDomain; label: string }> = [
  { value: "adaptive", label: "Adaptive" },
  { value: "behavior-reduction", label: "Behavior Reduction" },
  { value: "communication", label: "Communication" },
  { value: "community", label: "Community" },
  { value: "executive-functioning", label: "Executive Functioning" },
  { value: "social-skills", label: "Social Skills" },
];

export const STATUS_OPTIONS: Array<{ value: Status; label: string }> = [
  { value: "not-active", label: "Not Active" },
  { value: "in-progress", label: "In Progress" },
  { value: "on-hold", label: "On Hold" },
  { value: "met", label: "Met" },
  { value: "discontinued", label: "Discontinued" },
];
